module.exports = __webpack_public_path__ + "static/media/100aWeek.c733d2d1.png";